import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { OffsiteConfigProvider } from "./engine/app/offsite-context";
import { config } from "@active-offsite/offsite.config";
import "./styles/app.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

createRoot(root).render(
  <StrictMode>
    <OffsiteConfigProvider config={config}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OffsiteConfigProvider>
  </StrictMode>,
);
